import { m } from 'framer-motion';
// @mui
import { Container, Typography } from '@mui/material';
// hooks
import useAuth from '../hooks/useAuth';
// components
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { ForbiddenIllustration } from '../assets';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  hasContent?: boolean;
  roles?: string[];
  children: React.ReactNode;
};

export default function RoleBasedGuard({ hasContent, roles, children }: RoleBasedGuardProp) {
  // Phase 2.4: User.roles is an array (matches the BE shape), not a single
  // `role`. A user passes if ANY of their roles satisfies the required set,
  // OR if they hold 'super-admin' (Phase 1.2a inheritance).
  const { user } = useAuth();
  const userRoles: string[] = (user as any)?.roles ?? [];
  const isSuperAdmin = userRoles.includes('super-admin');
  const passes =
    typeof roles === 'undefined' ||
    isSuperAdmin ||
    roles.some((r) => userRoles.includes(r));

  if (!passes) {
    return hasContent ? (
      <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Permission Denied
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            You do not have permission to access this page
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>
      </Container>
    ) : null;
  }

  return <>{children}</>;
}
